import React, { FunctionComponent, useState } from "react";
import { Paper, Button, Grid, Typography, TextField } from "@material-ui/core";
import { Formik, Form, ErrorMessage } from "formik";
import * as yup from "yup";
import { SnackBar } from "../../SnackBar";
import { useDepartmentStyles } from "../useDepartmentStyles";
import { useStore } from "../../../store";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

type DepartmentFormProps = {
  dept_id: number;
  edit_data: Object;
  goToList: () => void;
  
};

export const DepartmentForm: FunctionComponent<DepartmentFormProps> = ({
  dept_id,
  edit_data,
  goToList,
 
}) => {
  const classes = useDepartmentStyles();
  const [departments, { updateDepartment, getDepartments }] = useStore(
    "departments"
  );
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const [departmentStatus, setDepartmentStatus] = useState<string>("");
  const [deptCode, setDeptCode] = useState<any>(null);
  
  const initialValues = {
    name: "",
    code: "",
    //status: null,
    report: false,
  };

  const updateSchema = yup.object().shape({
    name: yup.string().required("Department is required"),
    code: yup.string().required("Department Code is required"),
  });

  if (
    departments &&
    departments.find((i: any) => i.department_id === dept_id)
  ) {
    const departmentDetails = departments.find(
      (i: any) => i.department_id === dept_id
    );

    const { departmentname, code, report } = departmentDetails;
    initialValues.name = departmentname;
    initialValues.code = code;

    initialValues.report = report;
  }

  const checkCode = (value: any) => {
    const deptCode_list =
      departments && departments !== undefined
        ? Object.values(departments && departments).map(
            (value: any) => value.code
          )
        : "";

    if (deptCode_list.includes(value)) {
      setDeptCode(true);
    } else {
      setDeptCode(false);
    }
  };

  const handleSubmit = async (values: any) => {
    try {
      const result = await updateDepartment(dept_id, values);
      await getDepartments();
      if (result !== undefined) {
        setSnackbarColor("green");
        setDepartmentStatus("Department successfully updated");
      }
      setTimeout(() => {
        goToList();
      }, 2000);
    } catch (error) {
      if (deptCode) {
        setSnackbarColor("red");
        setDepartmentStatus("Department code already exist");
      } else {
        //console.log(error);
        setSnackbarColor("red");
        setDepartmentStatus("Department updation failed");
      }
    }
  };

  const onCloseSnackbar = () => {
    setDepartmentStatus("");
  };

  return (
    <div>
      <SnackBar
        status={departmentStatus}
        onCloseError={onCloseSnackbar}
        color={snackbarColor}
      />
      <Grid container></Grid>
      <Paper elevation={4} style={{ minHeight: "25em", minWidth: "50%" }}>
        <Grid container className={classes.mainGridStyle}>
          <Grid item>
            <Formik
              enableReinitialize
              validationSchema={updateSchema}
              initialValues={initialValues}
              onSubmit={(values) => {
                handleSubmit(values);
              }}
            >
              {({ values, handleChange, setFieldValue }) => (
                <Form>
                  <Grid container direction="row">
                    <Grid item xs>
                      <Grid
                        container
                        spacing={5}
                        className={classes.fieldSpace}
                      >
                        <Grid item xs={6}>
                          <Typography className={classes.fieldLabelStyles}>
                            Department Name
                          </Typography>
                          <TextField
                            variant="outlined"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            inputProps={{ maxLength: 50 }}
                            fullWidth={true}
                          />

                          <ErrorMessage name="name">
                            {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                          </ErrorMessage>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography className={classes.fieldLabelStyles}>
                            Department Code
                          </Typography>
                          <TextField
                            variant="outlined"
                            name="code"
                            value={values.code}
                            onChange={(e) => {
                              handleChange(e);
                              const domain = e.target.value; //.replace(/.*@/, '')
                              setFieldValue("code", domain);
                              checkCode(domain);
                            }}
                            inputProps={{ maxLength: 20 }}
                            fullWidth={true}
                          />

                          <ErrorMessage name="code">
                            {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                          </ErrorMessage>
                        </Grid>
                        <Grid item xs={6}>
                          <FormControlLabel
                            label="Show in Report"
                            control={
                              <Checkbox
                                checked={values.report}
                                onChange={handleChange}
                                name="report"
                                color="primary"
                                value={values.report}
                              />
                            }
                          />

                          <ErrorMessage name="report">
                            {(msg) => <div style={{ color: "red" }}>{msg}</div>}
                          </ErrorMessage>
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          sm={6}
                          direction="row"
                          style={{
                            display:
                              //   props.match.params.id === "new"
                              //     ? "none"
                              //     : "block",
                              "block",
                          }}
                        >
                          <Grid
                            container
                            direction="row"
                            spacing={1}
                            justify="flex-end"
                            alignItems="flex-end"
                            className={classes.commonButtonPosition}
                          >
                            <Grid
                              item
                              xs={6}
                              sm="auto"
                              className={classes.commonButtonStyle}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                type="reset"
                                size="medium"
                              >
                                <Typography>Clear</Typography>
                              </Button>
                            </Grid>
                            <Grid
                              item
                              xs={6}
                              sm="auto"
                              className={classes.commonButtonStyle}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                size="medium"
                              >
                                Submit
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
};
